import { Controller } from "@hotwired/stimulus"

// The full option list, kept against the element rather than against the controller:
// Stimulus treats a node moved in the DOM as removed then added, so `connect()` runs
// again, and a list captured there would have been the already filtered one. Dragging
// a colour rule through `sortable-position` and then changing its field left the
// dependent select with nothing to offer.
const allOptions = new WeakMap()

export default class extends Controller {
  static targets = ["source", "dependent"]

  connect() {
    this.filter()
  }

  filter() {
    const selectedValue = this.dependentTarget.value
    const matchingOptions = this.options.filter((option) => option.dataset.parentValue === this.sourceTarget.value)

    this.dependentTarget.replaceChildren(...matchingOptions)
    this.dependentTarget.value = selectedValue
    if (!this.dependentTarget.value) this.dependentTarget.selectedIndex = 0
  }

  get options() {
    if (!allOptions.has(this.dependentTarget)) {
      allOptions.set(this.dependentTarget, Array.from(this.dependentTarget.options))
    }

    return allOptions.get(this.dependentTarget)
  }
}
